import { Translate } from 'next-translate'

import { PointsLineProps } from '@/atoms/PointsLine/ts'

export function getLine(t: Translate): PointsLineProps['line'] {
  const recordsTranslated = ['signup_as_creator', 'add_product', 'thats_all']
  return recordsTranslated.map((item) => ({
    title: t(item),
    description: t(item + '_desc'),
  }))
}

